"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContext = exports.runInContext = exports.parseError = exports.SourceDocumentation = void 0;
const source_map_1 = require("source-map");
const createContext_1 = require("./createContext");
exports.createContext = createContext_1.default;
const runner_1 = require("./runner");
var docTooltip_1 = require("./editors/ace/docTooltip");
Object.defineProperty(exports, "SourceDocumentation", { enumerable: true, get: function () { return docTooltip_1.SourceDocumentation; } });
// needed to work on browsers
if (typeof window !== 'undefined') {
    // @ts-ignore
    source_map_1.SourceMapConsumer.initialize({
        'lib/mappings.wasm': 'https://unpkg.com/source-map@0.7.3/lib/mappings.wasm'
    });
}
function parseError(errors) {
    const errorMessagesArr = errors.map(error => {
        const line = error.location ? error.location.start.line : '<unknown>';
        const explanation = error.explain();
        return line < 1 ? explanation : `Line ${line}: ${explanation}`;
    });
    return errorMessagesArr.join('\n');
}
exports.parseError = parseError;
function runInContext(code, context, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, runner_1.sourceRunner)(code, context, options);
    });
}
exports.runInContext = runInContext;
//# sourceMappingURL=index.js.map